<template>
  <div>
    <div class="breadcrumb">
      <axe-breadcrumb separator-class="el-icon-arrow-right">
        <axe-breadcrumb-item>心育测评</axe-breadcrumb-item>
        <axe-breadcrumb-item>任务管理</axe-breadcrumb-item>
      </axe-breadcrumb>
    </div>
    <div class="content-box">
      <div class="list">
        <div class="list-left">
          <div
            v-for="(it, index) in moduleList"
            v-show="!it.isDistrict || it.isDistrict"
            :key="index"
            class="item"
            :class="{ active: areaOrSchool === it.tabs }"
            @click="chagePath(it)"
          >
            {{ it.label }}
          </div>
        </div>
      </div>
      <axe-form
        :inline="true"
        :model="params"
        @submit.native.prevent
      >
        <axe-form-item label="任务类型">
          <axe-select
            v-model="params.taskTypeId"
            class="w160"
            placeholder="请选择"
            size="small"
            @change="changeTaskType"
          >
            <axe-option
              label="全部"
              value=""
            />
            <axe-option
              v-for="(it, index) in typeList"
              :key="index"
              :label="it.name"
              :value="it.value"
            />
          </axe-select>
        </axe-form-item>
        <axe-form-item label="任务状态">
          <axe-select
            v-model="params.taskStatus"
            class="w160"
            placeholder="请选择"
            size="small"
            @change="getData(true)"
          >
            <axe-option
              label="全部"
              value=""
            />
            <axe-option
              v-for="(it, index) in statusList"
              :key="index"
              :label="it.name"
              :value="it.value"
            />
          </axe-select>
        </axe-form-item>
        <axe-form-item>
          <axe-input
            v-model="params.taskName"
            class="w272"
            size="small"
            placeholder="请输入测评名称进行搜索"
            @keyup.enter.native="getData(true)"
          >
            <span
              slot="suffix"
              class="icon"
              @click="getData(true)"
            ><i class="el-input__icon el-icon-search" /></span>
          </axe-input>
        </axe-form-item>
      </axe-form>
      <div class="tables">
        <axe-table
          ref="multipleTable"
          :data="tableData"
          style="width: 100%"
        >
          <axe-table-column
            prop="taskName"
            label="测评名称"
            show-overflow-tooltip
          />
          <axe-table-column
            label="任务类型"
            width="80px"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.taskType | filterType }}
            </template>
          </axe-table-column>
          <axe-table-column
            prop="publishName"
            label="发布者"
            width="70px"
            show-overflow-tooltip
          />
          <axe-table-column
            width="160px"
            label="施测对象"
          >
            <template slot-scope="scope">
              <axe-tooltip placement="top">
                <span
                  class="objectEllipsis ellipsis"
                  v-html="dataTargets(scope.row.taskTargets, scope.row.evaluationType)"
                />
                <span slot="content">
                  <div class="table-tooltip">
                    <span
                      v-for="(it, index) in scope.row.taskTargets"
                      :key="index"
                    >
                      <span v-if="scope.row.evaluationType === 1">{{ it.schoolName }}{{ it.gradeName }}{{ it.className }}</span>
                      <span v-else>{{ it.studentName }}</span>
                      <span v-if="index !== scope.row.taskTargets.length - 1">、</span>
                    </span>
                  </div>
                </span>
              </axe-tooltip>
            </template>
          </axe-table-column>
          <axe-table-column
            label="开始时间"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.taskStartTime | dateFilters }}
            </template>
          </axe-table-column>
          <axe-table-column
            label="结束时间"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.taskEndTime | dateFilters }}
            </template>
          </axe-table-column>
          <!-- 任务状态（0 未开始；  1 启动； 2 结束） -->
          <axe-table-column
            prop="taskStatus"
            label="状态"
            show-overflow-tooltip
            width="74px"
          >
            <template slot-scope="scope">
              <span
                class="circular"
                :class="[{'start': scope.row.taskStatus === 0}, {'ing': scope.row.taskStatus === 1}, {
                  'ending': scope.row.taskStatus === 2
                }]"
              >{{ statusText(scope.row.taskStatus) }}</span>
            </template>
          </axe-table-column>
          <axe-table-column
            label="操作"
            width="150"
          >
            <template slot-scope="scope">
              <!-- taskStatus（0 未开始；1 启动；2 结束；3 暂停） -->
              <axe-button
                class="opeatBtn"
                :disabled="scope.row.taskStatus === 0"
                type="text"
                @click="reportDetail(scope.row)"
              >
                查看
              </axe-button>
              <axe-button
                v-if="(scope.row.taskStatus === 0 || scope.row.taskStatus === 3) && taskIdentityStatus"
                class="opeatBtn border"
                type="text"
                @click="startTask(scope.row)"
              >
                开启
              </axe-button>
              <axe-button
                v-if="scope.row.taskStatus === 1 && taskIdentityStatus"
                class="opeatBtn border"
                type="text"
                @click="suspendTask(scope.row)"
              >
                暂停
              </axe-button>
              <axe-button
                v-if="scope.row.taskStatus === 2 && taskIdentityStatus"
                class="opeatBtn border"
                type="text"
                @click="deleteItenm(scope.row)"
              >
                删除
              </axe-button>

              <axe-popover
                placement="bottom"
                width="60"
                trigger="hover"
                popper-class="more-list"
              >
                <div class="more-btn">
                  <div class="more-li">
                    <axe-button
                      v-if="(scope.row.taskStatus === 1 || scope.row.taskStatus === 3 ) && taskIdentityStatus"
                      class="opeatBtn border"
                      type="text"
                      @click="endTask(scope.row)"
                    >
                      结束
                    </axe-button>
                  </div>
                  <div class="more-li">
                    <axe-button
                      v-if="taskIdentityStatus"
                      class="opeatBtn border"
                      type="text"
                      @click="changeModify(scope.row)"
                    >
                      修改
                    </axe-button>
                  </div>
                  <div class="more-li">
                    <axe-button
                      v-if="taskIdentityStatus"
                      class="opeatBtn border"
                      type="text"
                      @click="delay(scope.row)"
                    >
                      延期
                    </axe-button>
                  </div>
                </div>
                <axe-button
                  v-if="taskIdentityStatus"
                  slot="reference"
                  class="opeatBtn border"
                  type="text"
                >
                  更多
                </axe-button>
              </axe-popover>
            </template>
          </axe-table-column>
          <div
            slot="empty"
            class="empty"
          >
            <div class="jyxq-no-data">
              <div>暂无数据</div>
              <axe-button
                v-if="(areaOrSchool === 'school')
                  && tableData.length === 0 && requestEnd && doingNum && params.taskStatus === ''"
                size="small"
                type="primary"
                @click="issue"
              >
                发布测评任务
              </axe-button>
              <!-- 区级任务下不会有“发布测评任务”的按钮，只有无本校任务的时候才会有“发布测评任务”的按钮 -->
            </div>
          </div>
        </axe-table>
      </div>
      <pagination
        v-show="tableData.length"
        ref="pageNation"
        :page-size="page.pageSize"
        :page-num="page.pageNum"
        :total="total"
        @handleCurrent="handleCurrent"
      />
    </div>
  </div>
</template>

<script>
import pagination from "@/components/pagination";

export default {
  components: { pagination },
  filters: {
    filterType (val) {
      switch (val) {
        case '01':
          return '心理健康';
        case '02':
          return '心理发展';
        case '03':
          return '生涯发展';
      }
    },
    dateFilters (val) {
      if (val) {
        return val.substring(0, 16);
      }
    },
  },
  props: {},
  data () {
    return {
      areaOrSchool: "area",
      moduleList: [
        {
          label: "区级任务",
          path: "/measure/taskManagement/list?tabs=area",
          tabs: "area",
          isDistrict: true,
        },
        {
          label: "本校任务",
          path: "/measure/taskManagement/list?tabs=school",
          tabs: "school",
          isDistrict: false,
        },
      ],
      params: {
        taskTypeId: "",
        taskStatus: "",
        taskName: "",
      },
      tableData: [],
      total: 0,
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      disabledStart: false, // 是否禁用开始日期
      ruleForm: {
        taskId: "",
        taskStartTime: "",
        taskEndTime: "",
      },
      typeList: [
        { "name": "心理健康", "value": "01" },
        { "name": "心理发展", "value": "02" },
        { "name": "生涯发展", "value": "03" }
      ],
      // 0 未开始；1 启动；2 结束；3 暂停
      statusList: [
        { name: '未开始', value: 0, },
        { name: '进行中', value: 1, },
        { name: '已暂停', value: 3, },
        { name: '已结束', value: 2, }
      ],
      requestEnd: false,
      doingNum: false,
      isFirst: true,
      deleteTaslText: '', // 删除任务名称
      dialogForm: {
        taskId: "",
        taskName: "",
        taskIntroduction: "",
      },
      dialogRules: {
        taskName: { required: true, message: "此项不能为空", trigger: "blur" },
      },
      isSubmit: false,
      allData: [],
    };
  },
  computed: {
    // 校级心理老师可以操作校级任务 查看区级任务 区级心理老师只能操作区级任务
    taskIdentityStatus () {
      return (this.areaOrSchool === 'area') ||
        this.areaOrSchool === 'school';
    },
  },
  watch: {
  },
  created () {
    this.areaOrSchool = 'area';
    if (this.isFirst === true) {
      this.getData();
    }

  },
  mounted () {

  },
  methods: {
    composeValue (type, row) {
      return {
        type: type,
        row: row,
      };
    },
    // 处理表格状态
    statusText (val) {
      switch (val) {
        case 0:
          return '未开始';
        case 1:
          return '进行中';
        case 2:
          return '已结束';
        case 3:
          return '已暂停';
      }
    },
    // 处理数据渲染
    dataTargets (taskTargets, evaluationType) {
      let htmlText = '';
      if (taskTargets) {
        for (let i = 0; i < taskTargets.length; i++) {
          if (evaluationType === 1) {
            htmlText += `<span>${taskTargets[i].schoolName ? taskTargets[i].schoolName : ''}` +
              `${taskTargets[i].gradeName ? taskTargets[i].gradeName : ''}` +
              `${taskTargets[i].className ? taskTargets[i].className : ''}</span>`;
            htmlText += `<span>${i !== taskTargets.length - 1 ? '、' : ''}</span>`;
          } else if (evaluationType === 2) {
            htmlText += `<span>${taskTargets[i].studentName}</span>`;
            htmlText += `<span>${i !== taskTargets.length - 1 ? '、' : ''}</span>`;
          }
        }
      }
      return htmlText;
    },
    // 选中任务类型
    changeTaskType () {

    },
    // 当区级任务被提前结束后校级用户首次点进任务管理页面时
    chagePath (it) {
      this.params.taskTypeId = '';
      this.params.taskName = '';
      if (this.areaOrSchool !== it.tabs) {
        this.areaOrSchool = it.tabs;
        this.$router.push({
          path: '/measure/taskManagement/list',
          query: {
            tabs: it.tabs,
          },
        });
        this.getData(true);
      }
    },
    getData (val) {
      this.tableData = [];
      this.requestEnd = false;
      let res = {
        "pageNo": 1,
        "pageSize": 10,
        "totalCount": 20,
        "dataList": [
          {
            "businessId": "1616565527908992",
            "taskName": "区级任务1",
            "taskIntroduction": "",
            "taskType": "01",
            "taskStartTime": "2022-05-20 00:00:00",
            "taskEndTime": "2022-05-27 00:00:00",
            "publishName": "活动专家1",
            "taskStatus": 1,
            "orgId": "3513",
            "resourceId": null,
            "taskCreateType": 1,
            "evaluationType": 1,
            "taskTargets": [
              {
                "businessId": null,
                "taskId": "1616565527908992",
                "schoolId": "1500000200060858208",
                "schoolName": "智慧心育测试校3",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              }
            ]
          },
          {
            "businessId": "1616126432383616",
            "taskName": "测试校3区级任务",
            "taskIntroduction": "",
            "taskType": "01",
            "taskStartTime": "2022-05-20 00:00:00",
            "taskEndTime": "2022-05-20 19:36:16",
            "publishName": "活动专家1",
            "taskStatus": 2,
            "orgId": "3513",
            "resourceId": null,
            "taskCreateType": 1,
            "evaluationType": 1,
            "taskTargets": [
              {
                "businessId": null,
                "taskId": "1616126432383616",
                "schoolId": "1500000200060858208",
                "schoolName": "智慧心育测试校3",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              }
            ]
          },
          {
            "businessId": "1615523505574528",
            "taskName": "hc的测试回归量表测评任务",
            "taskIntroduction": "",
            "taskType": "01",
            "taskStartTime": "2022-05-20 00:00:00",
            "taskEndTime": "2022-05-25 15:38:00",
            "publishName": "活动专家2",
            "taskStatus": 1,
            "orgId": "3513",
            "resourceId": null,
            "taskCreateType": 1,
            "evaluationType": 1,
            "taskTargets": [
              {
                "businessId": null,
                "taskId": "1615523505574528",
                "schoolId": "1500000200060858208",
                "schoolName": "智慧心育测试校3",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              }
            ]
          },
          {
            "businessId": "1559020195174080",
            "taskName": "区5.10测试MSSMHS任务1：两个量表",
            "taskIntroduction": "任务简介1",
            "taskType": "01",
            "taskStartTime": "2022-05-10 00:00:00",
            "taskEndTime": "2022-05-20 16:31:00",
            "publishName": "活动专家2",
            "taskStatus": 2,
            "orgId": "3513",
            "resourceId": null,
            "taskCreateType": 1,
            "evaluationType": 1,
            "taskTargets": [
              {
                "businessId": null,
                "taskId": "1559020195174080",
                "schoolId": "1500000200060858208",
                "schoolName": "智慧心育测试校3",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1559020195174080",
                "schoolId": "1500000200060851312",
                "schoolName": "智慧心育测试校1",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              }
            ]
          },
          {
            "businessId": "1496305460270784",
            "taskName": "429任务（缺陷验证）",
            "taskIntroduction": "",
            "taskType": "01",
            "taskStartTime": "2022-04-29 00:00:00",
            "taskEndTime": "2022-05-10 10:19:09",
            "publishName": "心育区管",
            "taskStatus": 2,
            "orgId": "3513",
            "resourceId": null,
            "taskCreateType": 1,
            "evaluationType": 1,
            "taskTargets": [
              {
                "businessId": null,
                "taskId": "1496305460270784",
                "schoolId": "1500000200060852086",
                "schoolName": "智慧心育测试校2",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1496305460270784",
                "schoolId": "1500000200060938479",
                "schoolName": "智慧心育测试校6",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1496305460270784",
                "schoolId": "1500000200060858934",
                "schoolName": "智慧心育测试校4",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1496305460270784",
                "schoolId": "1500000200060858208",
                "schoolName": "智慧心育测试校3",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1496305460270784",
                "schoolId": "1500000200060999346",
                "schoolName": "智慧心育测试校11",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1496305460270784",
                "schoolId": "1500000200060851312",
                "schoolName": "智慧心育测试校1",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              }
            ]
          },
          {
            "businessId": "1496269327849152",
            "taskName": "1234测评任务",
            "taskIntroduction": "",
            "taskType": "01",
            "taskStartTime": "2022-04-29 00:00:00",
            "taskEndTime": "2022-04-29 17:50:46",
            "publishName": "活动专家2",
            "taskStatus": 2,
            "orgId": "3513",
            "resourceId": null,
            "taskCreateType": 1,
            "evaluationType": 1,
            "taskTargets": [
              {
                "businessId": null,
                "taskId": "1496269327849152",
                "schoolId": "1500000200060852086",
                "schoolName": "智慧心育测试校2",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1496269327849152",
                "schoolId": "1500000200060938479",
                "schoolName": "智慧心育测试校6",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1496269327849152",
                "schoolId": "1500000200060858934",
                "schoolName": "智慧心育测试校4",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1496269327849152",
                "schoolId": "1500000200060858208",
                "schoolName": "智慧心育测试校3",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1496269327849152",
                "schoolId": "1500000200060999346",
                "schoolName": "智慧心育测试校11",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1496269327849152",
                "schoolId": "1500000200060851312",
                "schoolName": "智慧心育测试校1",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1496269327849152",
                "schoolId": "1500000200060939037",
                "schoolName": "智慧心育测试校5",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              }
            ]
          },
          {
            "businessId": "1495451591530176",
            "taskName": "四月二十九测评任务",
            "taskIntroduction": "",
            "taskType": "01",
            "taskStartTime": "2022-04-29 00:00:00",
            "taskEndTime": "2022-05-03 00:00:00",
            "publishName": "活动专家2",
            "taskStatus": 2,
            "orgId": "3513",
            "resourceId": null,
            "taskCreateType": 1,
            "evaluationType": 1,
            "taskTargets": [
              {
                "businessId": null,
                "taskId": "1495451591530176",
                "schoolId": "1500000200060852086",
                "schoolName": "智慧心育测试校2",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1495451591530176",
                "schoolId": "1500000200060938479",
                "schoolName": "智慧心育测试校6",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1495451591530176",
                "schoolId": "1500000200060858934",
                "schoolName": "智慧心育测试校4",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1495451591530176",
                "schoolId": "1500000200060858208",
                "schoolName": "智慧心育测试校3",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1495451591530176",
                "schoolId": "1500000200060999346",
                "schoolName": "智慧心育测试校11",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1495451591530176",
                "schoolId": "1500000200060851312",
                "schoolName": "智慧心育测试校1",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1495451591530176",
                "schoolId": "1500000200060939037",
                "schoolName": "智慧心育测试校5",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              }
            ]
          },
          {
            "businessId": "1490659983692416",
            "taskName": "区4.27任务10：两个量表",
            "taskIntroduction": "任务简介10",
            "taskType": "01",
            "taskStartTime": "2022-04-28 14:23:00",
            "taskEndTime": "2022-04-29 00:00:00",
            "publishName": "活动专家2",
            "taskStatus": 2,
            "orgId": "3513",
            "resourceId": null,
            "taskCreateType": 1,
            "evaluationType": 1,
            "taskTargets": [
              {
                "businessId": null,
                "taskId": "1490659983692416",
                "schoolId": "1500000200060858208",
                "schoolName": "智慧心育测试校3",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1490659983692416",
                "schoolId": "1500000200060851312",
                "schoolName": "智慧心育测试校1",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              }
            ]
          },
          {
            "businessId": "1486666269332096",
            "taskName": "区4.27任务7：健康预警量表均分（倒序误删）测评任务",
            "taskIntroduction": "任务简介7",
            "taskType": "01",
            "taskStartTime": "2022-04-27 21:28:00",
            "taskEndTime": "2022-04-29 08:45:00",
            "publishName": "活动专家2",
            "taskStatus": 2,
            "orgId": "3513",
            "resourceId": null,
            "taskCreateType": 1,
            "evaluationType": 1,
            "taskTargets": [
              {
                "businessId": null,
                "taskId": "1486666269332096",
                "schoolId": "1500000200060858208",
                "schoolName": "智慧心育测试校3",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1486666269332096",
                "schoolId": "1500000200060851312",
                "schoolName": "智慧心育测试校1",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              }
            ]
          },
          {
            "businessId": "1485393594684032",
            "taskName": "区4.27任务8：PHQ-9抑郁自评量表测评任务",
            "taskIntroduction": "任务简介8",
            "taskType": "01",
            "taskStartTime": "2022-04-27 00:00:00",
            "taskEndTime": "2022-04-30 00:00:00",
            "publishName": "活动专家2",
            "taskStatus": 2,
            "orgId": "3513",
            "resourceId": null,
            "taskCreateType": 1,
            "evaluationType": 1,
            "taskTargets": [
              {
                "businessId": null,
                "taskId": "1485393594684032",
                "schoolId": "1500000200060858208",
                "schoolName": "智慧心育测试校3",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1485393594684032",
                "schoolId": "1500000200060851312",
                "schoolName": "智慧心育测试校1",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              }
            ]
          },
          {
            "businessId": "1484065944786624",
            "taskName": "区4.27任务3：两个量表@",
            "taskIntroduction": "任务简介3任务简介1拉空间两个空格拉萨的客户交付",
            "taskType": "01",
            "taskStartTime": "2022-04-27 10:26:00",
            "taskEndTime": "2022-04-27 22:51:13",
            "publishName": "活动专家2",
            "taskStatus": 2,
            "orgId": "3513",
            "resourceId": null,
            "taskCreateType": 1,
            "evaluationType": 1,
            "taskTargets": [
              {
                "businessId": null,
                "taskId": "1484065944786624",
                "schoolId": "1500000200060858208",
                "schoolName": "智慧心育测试校3",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1484065944786624",
                "schoolId": "1500000200060851312",
                "schoolName": "智慧心育测试校1",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              }
            ]
          },
          {
            "businessId": "1483677471871616",
            "taskName": "区4.27任务2：两个量表@@@@@@@@@@@@@@@@@",
            "taskIntroduction": "任务简介2任务简介1拉空间两个空格拉萨的客户交付萨科回复撒零九分高峰时段浪费空间撒旦很复古发射点立刻就韩股份回购汇入就过热韩狗日管理局撒旦和的广泛广泛链接发哈恢复了活力和结果还是两个链接按时交付吉萨回复国家大呼管理法发了个发了房间哈格拉好几个哈里斯解放军客户发放奖励哈嘎飞机喀什立法和卡拉回复格拉克干哈flask几分好感发就会考虑发生了尬死了官方撒和法兰克会发生了解客户过来看附件是大神了记录回复撒离",
            "taskType": "01",
            "taskStartTime": "2022-04-27 08:47:42",
            "taskEndTime": "2022-04-27 10:00:00",
            "publishName": "活动专家2",
            "taskStatus": 2,
            "orgId": "3513",
            "resourceId": null,
            "taskCreateType": 1,
            "evaluationType": 1,
            "taskTargets": [
              {
                "businessId": null,
                "taskId": "1483677471871616",
                "schoolId": "1500000200060858208",
                "schoolName": "智慧心育测试校3",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1483677471871616",
                "schoolId": "1500000200060851312",
                "schoolName": "智慧心育测试校1",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              }
            ]
          },
          {
            "businessId": "1483564624253568",
            "taskName": "区4.27任务1：两个量表@@@@@@@@@@@@@@@@@",
            "taskIntroduction": "任务简介1拉空间两个空格拉萨的客户交付萨科回复撒零九分高峰时段浪费空间撒旦很复古发射点立刻就韩股份回购汇入就过热韩狗1管理局撒旦和的广泛广泛链接发哈恢复了活力和结果还是两个链接按时交付吉萨回复国家大呼管理法发了个发了房间哈格拉好几个哈里斯解1军客户发放奖励哈嘎飞机喀什立法和卡拉回复格拉克干哈flask几分好感发就会考虑发生了尬死了官方撒和法兰克会发生了解客户过来看附件是大神了记录回复撒离开皇宫拉客",
            "taskType": "01",
            "taskStartTime": "2022-04-27 08:19:00",
            "taskEndTime": "2022-04-28 00:00:00",
            "publishName": "活动专家2",
            "taskStatus": 2,
            "orgId": "3513",
            "resourceId": null,
            "taskCreateType": 1,
            "evaluationType": 1,
            "taskTargets": [
              {
                "businessId": null,
                "taskId": "1483564624253568",
                "schoolId": "1500000200060858208",
                "schoolName": "智慧心育测试校3",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1483564624253568",
                "schoolId": "1500000200060851312",
                "schoolName": "智慧心育测试校1",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              }
            ]
          },
          {
            "businessId": "1480082769270464",
            "taskName": "区4.26任务8：两个量表@@",
            "taskIntroduction": "任务简介8@@",
            "taskType": "01",
            "taskStartTime": "2022-04-26 17:37:00",
            "taskEndTime": "2022-04-27 08:12:14",
            "publishName": "活动专家2",
            "taskStatus": 2,
            "orgId": "3513",
            "resourceId": null,
            "taskCreateType": 1,
            "evaluationType": 1,
            "taskTargets": [
              {
                "businessId": null,
                "taskId": "1480082769270464",
                "schoolId": "1500000200060858208",
                "schoolName": "智慧心育测试校3",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1480082769270464",
                "schoolId": "1500000200060851312",
                "schoolName": "智慧心育测试校1",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              }
            ]
          },
          {
            "businessId": "1479845271393984",
            "taskName": "区4.26任务7：PHQ-9抑郁自评量表测评任务",
            "taskIntroduction": "",
            "taskType": "01",
            "taskStartTime": "2022-04-26 00:00:00",
            "taskEndTime": "2022-04-27 00:00:00",
            "publishName": "活动专家2",
            "taskStatus": 2,
            "orgId": "3513",
            "resourceId": null,
            "taskCreateType": 1,
            "evaluationType": 1,
            "taskTargets": [
              {
                "businessId": null,
                "taskId": "1479845271393984",
                "schoolId": "1500000200060858208",
                "schoolName": "智慧心育测试校3",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              }
            ]
          },
          {
            "businessId": "1479520309875328",
            "taskName": "区4.26任务5：两个量表",
            "taskIntroduction": "任务简介5",
            "taskType": "01",
            "taskStartTime": "2022-04-26 00:00:00",
            "taskEndTime": "2022-04-27 08:12:21",
            "publishName": "活动专家2",
            "taskStatus": 2,
            "orgId": "3513",
            "resourceId": null,
            "taskCreateType": 1,
            "evaluationType": 1,
            "taskTargets": [
              {
                "businessId": null,
                "taskId": "1479520309875328",
                "schoolId": "1500000200060858208",
                "schoolName": "智慧心育测试校3",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1479520309875328",
                "schoolId": "1500000200060851312",
                "schoolName": "智慧心育测试校1",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              }
            ]
          },
          {
            "businessId": "1478460009157248",
            "taskName": "区4.26任务4：PHQ-9抑郁自评量表测评任务",
            "taskIntroduction": "任务简介4",
            "taskType": "01",
            "taskStartTime": "2022-04-26 10:41:00",
            "taskEndTime": "2022-04-26 19:32:08",
            "publishName": "活动专家2",
            "taskStatus": 2,
            "orgId": "3513",
            "resourceId": null,
            "taskCreateType": 1,
            "evaluationType": 1,
            "taskTargets": [
              {
                "businessId": null,
                "taskId": "1478460009157248",
                "schoolId": "1500000200060858208",
                "schoolName": "智慧心育测试校3",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1478460009157248",
                "schoolId": "1500000200060851312",
                "schoolName": "智慧心育测试校1",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              }
            ]
          },
          {
            "businessId": "1478216437814976",
            "taskName": "区4.26任务3：PHQ-9抑郁自评量表测评任务",
            "taskIntroduction": "任务简介3",
            "taskType": "01",
            "taskStartTime": "2022-04-26 00:00:00",
            "taskEndTime": "2022-04-27 00:00:00",
            "publishName": "活动专家2",
            "taskStatus": 2,
            "orgId": "3513",
            "resourceId": null,
            "taskCreateType": 1,
            "evaluationType": 1,
            "taskTargets": [
              {
                "businessId": null,
                "taskId": "1478216437814976",
                "schoolId": "1500000200060858208",
                "schoolName": "智慧心育测试校3",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1478216437814976",
                "schoolId": "1500000200060851312",
                "schoolName": "智慧心育测试校1",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              }
            ]
          },
          {
            "businessId": "1478156226942656",
            "taskName": "区4.26任务2：两个量表",
            "taskIntroduction": "任务简介2",
            "taskType": "01",
            "taskStartTime": "2022-04-26 00:00:00",
            "taskEndTime": "2022-04-27 00:00:00",
            "publishName": "活动专家2",
            "taskStatus": 2,
            "orgId": "3513",
            "resourceId": null,
            "taskCreateType": 1,
            "evaluationType": 1,
            "taskTargets": [
              {
                "businessId": null,
                "taskId": "1478156226942656",
                "schoolId": "1500000200060858208",
                "schoolName": "智慧心育测试校3",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1478156226942656",
                "schoolId": "1500000200060851312",
                "schoolName": "智慧心育测试校1",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              }
            ]
          },
          {
            "businessId": "1478111003039424",
            "taskName": "区4.26任务1：两个量表",
            "taskIntroduction": "任务简介1",
            "taskType": "01",
            "taskStartTime": "2022-04-26 09:37:39",
            "taskEndTime": "2022-04-27 00:00:00",
            "publishName": "活动专家2",
            "taskStatus": 2,
            "orgId": "3513",
            "resourceId": null,
            "taskCreateType": 1,
            "evaluationType": 1,
            "taskTargets": [
              {
                "businessId": null,
                "taskId": "1478111003039424",
                "schoolId": "1500000200060858208",
                "schoolName": "智慧心育测试校3",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              },
              {
                "businessId": null,
                "taskId": "1478111003039424",
                "schoolId": "1500000200060851312",
                "schoolName": "智慧心育测试校1",
                "gradeId": null,
                "gradeName": null,
                "classId": null,
                "className": null,
                "studentId": null,
                "studentName": null
              }
            ]
          }
        ],
        "maxOptionNum": null
      }
      this.allData = res.dataList;
      this.tableData = this.allData.slice(0, 10);
      this.total = res.totalCount;
      this.requestEnd = true;
    },
    /** 分页 */
    handleCurrent (val) {
      this.page.pageNum = val;
      if (val === 1) {
        this.tableData = this.allData.slice(0, 10);
      } else {
        this.tableData = this.allData.slice(10 * (this.page.pageNum - 1), 10 * this.page.pageNum);
      }
    },
    reportDetail (row) {

    },
    /** 修改名称和简介 */
    changeModify (row) {

    },
    /** （0 未开始；  1 启动； 2 结束 3暂停） */
    startTask (row) {

    },
    /** 暂停任务 */
    suspendTask (row) {


    },
    endTask (row) {

    },
    //延期taskStatus（0 未开始；  1 启动； 2 结束 3暂停）
    delay (row) {

    },
    //删除
    deleteItenm (row) {

    },
    // 发布
    /** @type 2创建 @orgin 1量表 2任务 */
    issue () {

    },
  },
};
</script>

<style lang="scss">
// 隐藏时间控件组件上的此刻按钮
.date-text-none {
  .el-picker-panel__footer {
    .el-button--text {
      display: none;
    }
  }
}

.more-list {
  padding: 4px 0;
  min-width: 96px;
  text-align: center;
  .opeatBtn {
    padding: 9px 12px;
    color: #262626;
    &:hover {
      color: #368fff;
    }
  }
  .more-li {
    &:hover {
      background: rgba(54, 143, 255, 0.1);
    }
  }
}
</style>
<style scoped lang="scss">
.w180.el-input {
  width: 180px;
}
.w348 {
  width: 348px;
}
.dialog-form {
  .el-form-item {
    margin-bottom: 12px;
    &.inline {
      margin-bottom: 0;
    }
    ::v-deep.el-form-item__error {
      position: relative;
    }
    ::v-deep .el-textarea .el-input__count {
      line-height: 20px;
    }
  }
}
.content-box {
  padding: 0 24px 24px;
  background: #fff;
  border-radius: 4px;
  min-height: calc(100vh - 80px);
}
.list {
  margin-bottom: 12px;
  .list-left {
    width: 100%;
    line-height: 45px;
    display: inline-block;
    border-bottom: 1px solid #f0f1f4;
  }
  .item {
    cursor: pointer;
    font-size: 14px;
    color: #262626;
    display: inline-block;
    margin-right: 36px;
    border-bottom: 2px solid #fff;
    &.active {
      color: #368fff;
      border-bottom: 2px solid #368fff;
    }
  }
}
.w160 {
  width: 160px;
}
.w272 {
  width: 272px;
}
.el-form-item {
  margin-bottom: 12px;
}
.tables {
  margin-bottom: 24px;
  .opeatBtn {
    padding: 0;
    margin: 0 8px 0 0;
  }
  .border {
    border-left: 1px solid #f0f0f0;
    padding-left: 8px;
  }
  .circular::before {
    display: inline-block;
    content: '';
    margin-right: 6px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #ffae00;
  }
  .ing::before {
    background: #24c366;
  }
  .start::before {
    background: #368fff;
  }
  .ending::before {
    background: #8c8c8c;
  }
  .more-btn {
  }
}
.table-tooltip {
  max-width: 900px;
}
.el-input {
  &:hover {
    .el-icon-search {
      color: #368fff;
      cursor: pointer;
    }
  }
}
.el-dropdown {
  margin-left: 10px;
}
.empty {
  position: relative;
  height: 400px;
}
.jyxq-no-data {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 auto;
  text-align: center;
  img {
    vertical-align: middle;
  }
  div {
    color: #8c8c8c;
    font-size: 14px;
    line-height: 20px;
  }
}
.el-form {
  .el-form-item {
    display: inline-block;
  }
  .col {
    margin: 0 16px;
    color: #6f6f6f;
  }
}
.objectEllipsis {
  display: inline-block;
  max-width: 100%;
}
.issue-form {
  .el-form-item {
    margin-bottom: 6px;
  }
}
.task-dialog {
  ::v-deep.el-dialog__footer {
    padding: 0;
  }
}
.dialog-footer {
  padding: 10px 0 20px 0;
  text-align: right;
  .el-button {
    width: 90px;
  }
}
.breadcrumb {
  margin: 0 0 16px 0;
}
</style>
